import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuttcProposalComponent } from './euttc-proposal.component';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreCommonModule } from '../../../@core/common.module';
import { CardSnippetModule } from '../../../@core/components/card-snippet/card-snippet.module';
import { ContentHeaderModule } from '../../../app/layout/components/content-header/content-header.module';
import { NouisliderModule } from 'ng2-nouislider';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { NgSelectModule } from '@ng-select/ng-select';
import { FileUploadModule } from 'ng2-file-upload';
import { ToastrModule } from 'ngx-toastr';
import { DirectivesModule } from '../directives/directives.module';
import { AuthGuard } from '../../auth/helpers';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { Role } from 'app/auth/models';
import { EuttcProposalService } from './euttc-proposal.service';






const routes: Routes = [
  {
    path: 'euttc-proposal',
    component: EuttcProposalComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.User]},
    
  },
  {
    path: 'euttc-proposal/:id',
    component: EuttcProposalComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.User]},
  }
  
];



@NgModule({
  declarations: [
    EuttcProposalComponent
  ],
  
   imports: [
      RouterModule.forChild(routes), NgbModule, ContentHeaderModule, CardSnippetModule, CoreCommonModule,
      NouisliderModule, NgSelectModule, 
      FileUploadModule, ChartsModule, NgApexchartsModule,
      ToastrModule, DirectivesModule
    ],
    exports: [EuttcProposalComponent, DirectivesModule],
    providers: [
      // {
      //   provide: SWIPER_CONFIG,
      //   useValue: DEFAULT_SWIPER_CONFIG
      // },
      EuttcProposalService
    ]
})
export class EuttcProposalModule { }
